import { createRoute } from '@tanstack/react-router'

import { appRoute } from '@/app'

export const rootRoute = createRoute({
    getParentRoute: () => appRoute,
    path: '/product',
})
